import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '@app/services';
import { PATH } from '@app/constants';

@Injectable({ providedIn: 'root' })
export class IsNotAuthGuard  {

  constructor(private authServ: AuthService, private router: Router) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authServ.tokenIsActive()) {
      this.router.navigateByUrl(PATH.ROUTE_DASHBOARD_HOME);
      return false;
    }

    return true;
  }

}
